
import { CustomObjectResponse } from "../types/CustomObjects";
import { CustomObjectRecordsResponse } from "../types/CustomRecords";
import { zendeskRequest } from "./zendesk";


export function listRecords<TFields>(custom_object_key: string) {
    return zendeskRequest<CustomObjectRecordsResponse<TFields>>(
        `/api/v2/custom_objects/${custom_object_key}/records`,
        "GET"
    );
}

export function listRecordsWithParams<TFields>(
    custom_object_key: string,
    queryParams?: Record<string, any>
) {
    // Converte os queryParams em uma string de parâmetros de URL
    const queryString = queryParams
        ? `?${new URLSearchParams(queryParams).toString()}`
        : '';

    return zendeskRequest<CustomObjectRecordsResponse<TFields>>(
        `/api/v2/custom_objects/${custom_object_key}/records${queryString}`,
        "GET"
    );
}

export function createRecord(custom_object_key: string, data: object) {
    const { name, external_id, ...fields } = data as any;

    return zendeskRequest<CustomObjectResponse>(
        `/api/v2/custom_objects/${custom_object_key}/records`,
        "POST",
        {
            custom_object_record: {
                name,
                external_id: external_id ?? null,
                custom_object_fields: fields,
            },
        }
    );
}